












































import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import SelectiveProcessService from '@/domain/selective-process/service/selective-process.service';
import { VbSnackbarService } from 'bag-of-holding-library';
import CandidateResetSurveyHistory from '@/domain/selective-process/entity/candidate/candidate-reset-survey-history.entity';
import moment from 'moment';
import Loading from '@/shared/loading/loading.component.vue';

@Component({
  components: {
    ModalComponent,
    Loading,
  },
})
export default class ResetHistoryModal extends Vue {
  @Prop() openModal!: boolean;

  @Prop({
    type: String,
    required: true,
  }) candidateAssessmentId!: string;

  loading: boolean = false;

  histories: CandidateResetSurveyHistory[] = [];

  get optionsHandled(): ModalOptions {
    return {
      title: 'Histórico de Redefinição de Testes',
      titleSize: '20px',
      description: '',
      showOk: false,
      showCancel: true,
      labelCancel: 'fechar',
      width: 500,
    };
  }

  created() {
    this.getResetHistory();
  }

  closeModal() {
    this.$emit('close');
  }

  async getResetHistory() {
    this.loading = true;
    try {
      const history = await SelectiveProcessService.getResetHistory(this.candidateAssessmentId);
      this.histories = history;
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.loading = false;
    }
  }

  formatDate(date: string) {
    return moment(date).format('DD/MM/YYYY HH:mm');
  }
}
